import type { TagColor } from "Components/Analyses/_Shared/Tag";
import type { ClientAddressParts } from "Infrastructure/ApiZfp/Schema";
import { type ResourcePathType, Resources } from "Infrastructure/Translations/Resources";
import { ClientCardState } from "Infrastructure/Utils/ClientUtils";
import { inflectYears } from "Infrastructure/Utils/LanguageUtils";
import { differenceInYears } from "date-fns";

export const CLIENT_CARD_TAG: Record<ClientCardState, { label: ResourcePathType; color: TagColor }> = {
  [ClientCardState.NotInMango]: { label: Resources.Clients.ClientCard.Status.NotInMangoUp, color: "warning" },
  [ClientCardState.Missing]: { label: Resources.Clients.ClientCard.Status.Missing, color: "warning" },
  [ClientCardState.Unsigned]: { label: Resources.Clients.ClientCard.Status.Unsigned, color: "grey" },
  [ClientCardState.Outdated]: { label: Resources.Clients.ClientCard.Status.Outdated, color: "warning" },
  [ClientCardState.Actual]: { label: Resources.Clients.ClientCard.Status.Actual, color: "success" },
};

export const formatBirthDateWithAge = (
  birthDate: string | null | undefined,
  formatDate: (date: Date) => string,
  t: Parameters<typeof inflectYears>[1],
): string | undefined => {
  if (!birthDate) return undefined;
  const date = new Date(birthDate);
  return `${formatDate(date)} (${inflectYears(differenceInYears(new Date(), date), t)})`;
};

export const formatCityAndPostalCode = (address: ClientAddressParts | null | undefined): string | undefined =>
  [address?.city, address?.postalCode].filter(Boolean).join(", ") || undefined;
